import { tuApptoAPI, getAuthHeaders, getErrorData } from './config'

const headers = getAuthHeaders().headers
export const findAll = async request => {
  try {
    const response = await tuApptoAPI.post('/notices/findall', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const create = async request => {
  try {
    const response = await tuApptoAPI.post('/notices/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const remove = async id => {
  try {
    const response = await tuApptoAPI.delete(`/notices/delete/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}
